import TabsCustom from '@/components/_common/TabsCustom';
import BankSlipConfiguration from '@/components/Settings/Financial/BankSlipConfiguration';
import TagsAccountsPayableAndReceivable from '@/components/Settings/Financial/TagsAccountsPayableAndReceivable';
import { useWindowSize } from '@/hooks';
import { PageProps } from '@/types/PageProps';
import { Badge, Divider, Typography } from 'antd';
import { useState } from 'react';
import { Helmet } from 'react-helmet';
import { useIntl } from 'react-intl';

const { Title } = Typography;

export const initialTabErrors = {
  bankSlip: false,
  tags: false,
};

export default function FinancialSettingsPage({ route }: PageProps) {
  const intl = useIntl();
  const { width } = useWindowSize();

  const [menuKeyActive, setMenuKeyActive] = useState<string>('tags');
  const [tabErrors, setTabErrors] = useState(initialTabErrors);

  function handleTabError(key: keyof typeof initialTabErrors) {
    setTabErrors((state) => ({ ...state, [key]: true }));
  }

  return (
    <>
      <Helmet title={intl.formatMessage({ id: route.name })} />

      <div className="page-header">
        <Title level={width < 576 ? 5 : 4}>
          {intl.formatMessage({ id: route.name })}
        </Title>
      </div>

      <Divider />

      <TabsCustom
        key={menuKeyActive}
        activeKey={menuKeyActive}
        onChange={setMenuKeyActive}
      >
        <TabsCustom.Item
          icon={tabErrors?.bankSlip ? <Badge dot /> : null}
          label="Etiquetas Contas a Pagar/Receber"
          key="tags"
        >
          <TagsAccountsPayableAndReceivable handleTabError={handleTabError} />
        </TabsCustom.Item>

        <TabsCustom.Item
          icon={tabErrors?.bankSlip ? <Badge dot /> : null}
          label="Boleto"
          key="bankSlip"
        >
          <BankSlipConfiguration
            handleTabError={handleTabError}
            menuActive={menuKeyActive === 'bankSlip'}
          />
        </TabsCustom.Item>
      </TabsCustom>
    </>
  );
}
